import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import RemoveIcon from "@mui/icons-material/Remove";
import IconButton from "@mui/material/IconButton";
import { GridRenderCellParams, GridRowsProp } from "@mui/x-data-grid";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useParams } from "react-router-dom";
import theme from "../../../../assets/theme";


interface IsActiveFieldProps extends GridRenderCellParams {
    updateApiFunc: (projectId: string | number, node: any) => Promise<any>;
    rows: GridRowsProp;
    setRows: (rows: GridRowsProp) => void;
    isActive0?: boolean;  // переключатель нулевой последовательности
}
const IsActiveField = observer((props: IsActiveFieldProps) => {
    const params = useParams();
    const projectId: number = +(params.projectId || 0);

    const toggleIsActiveValue = () => {
        if (props.updateApiFunc) {
            const new_is_active = !props.value;
            props.updateApiFunc(projectId, {...props.row, [props.field]: new_is_active})
                .then(() => {
                    for (let i = 0; i < props.rows.length; i++) {
                        if (props.rows[i].id === props.row.id) {
                            props.setRows([
                                ...props.rows.slice(0, i),
                                {...props.rows[i], [props.field]: new_is_active},
                                ...props.rows.slice(i+1, props.rows.length),
                            ]);
                            break;
                        }
                    }
                });
        }
    };

    if (props.value) {
        return (
            <IconButton onClick={toggleIsActiveValue}>
                <CheckIcon color="success" />
            </IconButton>
        );
    } else if (!props.isActive0) {
        return (
            <IconButton onClick={toggleIsActiveValue}>
                <ClearIcon color="error" />
            </IconButton>
        );
    }
    return (
        <IconButton onClick={toggleIsActiveValue} sx={{color: theme.palette.grey.A700}}>
            <RemoveIcon color="inherit" />
        </IconButton>
    );
});


export default IsActiveField;
